const API_KEY = "AIzaSyATTHrrvYDdYE2x5wjJCIMTI3sl-TeD9Jk";

export default API_KEY;

// search id >>> 1ad1c230bfd086df4